
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'security-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'security-bundle')

export default [
  {
    name: 'security.agents',
    path: 'agents',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'security.agents.new',
        path: 'create',
        component: Form
      },
      {
        name: 'security.agents.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/security/agents/routes.js